import * as React from 'react'

import { SearchField } from '@factorialco/deprecated-design-system'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import i18n from 'modules/core/lib/i18n'

type Props = {
  search: string
  onSearch: (search: string) => void
  disabled?: boolean
}

export const PreferencesSearchBar = ({ search, onSearch, disabled }: Props) => {
  const handleSearch = useUnsafeCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onSearch(event.target.value)
    },
    [onSearch]
  )

  return (
    <SearchField
      variant="big"
      placeholder={i18n.t('notifications.preferences.search_placeholder')}
      search={search}
      disabled={disabled}
      onSearch={handleSearch}
    />
  )
}
